<template>
  <div class="my-2">
    <v-row align="center">
      <v-col class="text-center" cols="12" sm="12">
        <v-dialog v-model="dialogChangePassword" persistent max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              text 
              link 
              color="primary"
              v-bind="attrs"
              v-on="on"
              v-on:click="getUser"
            >
              Change Password
            </v-btn>
          </template>
          <v-card 
            class="mx-auto"
            :loading="loading">
            <v-card-title>
              <span class="headline">Change Password</span>
              <v-spacer></v-spacer>
              <v-btn 
                text @click="close"
              >
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-subtitle>
              <span>{{ currentUser.first_name }}, {{currentUser.last_name}}</span>              
            </v-card-subtitle>
            <v-card-text>
              <v-form ref="changePasswordForm" model="valid" autocomplete="new-password">
                <v-alert
                  :value="alert"
                  color="error"
                  dark
                  icon="mdi-alert"
                  transition="scale-transition"
                  outlined
                >
                  {{ message }}
                </v-alert>
                <v-text-field
                  v-model="currentUser.username"
                  label="Username"
                  readonly
                ></v-text-field>
                <v-text-field
                  v-model="currentUser.password"
                  placeholder="Enter Current Password"
                  required
                  label="Password"
                  :type="false ? 'text' : 'password'"
                  autocomplete="new-password"
                  :rules="[rules.required]"
                  :value="userPassword"
                  @click:append="() => (value = !value)"
                  @input="_=>userPassword=_"
                />
                <v-text-field
                  v-model="currentUser.password1"
                  placeholder="Enter New Password"
                  required
                  label="New Password"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
                  autocomplete="new-password"
                  :rules="[rules.required, rules.password, passwordChangeRule]"
                />
                <v-text-field
                  v-model="currentUser.password2"
                  placeholder="Retype New Password"
                  required
                  label="Verify Password"
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show2 ? 'text' : 'password'"
                  @click:append="show2 = !show2"
                  autocomplete="new-password"
                  :rules="[rules.required, rules.password, passwordConfirmationRule]"
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="mr-4" @click="changePassword">Ok</v-btn>
              <v-btn @click="clear">Clear</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row> 
  </div>
</template>
  
<script>
export default {
  name: 'preferences',
  cache: false,
  data: function() {
    return {
      loading: false,
      message: null,
      currentUser: {},
      dialogChangePassword: false,
      show1: false,
      show2: false,
      show3: false,
      userPassword: "",
      valid: true,
      value: true,
      rules: {
        required: value => !!value || "Required.",
        password: value => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
          return (
            pattern.test(value) ||
            "Min. 8 characters with at least one capital letter, a number and a special character."
          );
        },
        confirmed: value => value != this.currentUser.password1 || "Password no match" ,
      },
      alert: false,
      err: '',
    }
  },
  updated: function() {
//     this.show1=false
//     this.show2=false
//     this.show3=false
  },
  computed: {
    passwordChangeRule() {
      return () => (this.currentUser.password0 != this.currentUser.password1) || 'New Password must be different'
    },
    passwordConfirmationRule() {
      return () => (this.currentUser.password1 === this.currentUser.password2) || 'Password must match'
    },
  },
  methods: {
    getUser: function() {
      this.loading = true;
      this.$http.get(this.$base + '/api/v1' + this.$session.get('site') + '/user/current/')
          .then((response) => {
            this.currentUser= response.data;
  //           this.$refs.modal.show();
            console.log(this.currentUser)
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            alert(err);
          })
    },
    changePassword: function(evt) {
      if (evt) evt.preventDefault();
      if (!this.$session.exists('site')) {
        alert("No client session found");
        return;
      }
      this.loading = true;
      this.message = '';
      this.$http.post(this.$base + '/api/v1' + this.$session.get('site') + '/user/' + this.currentUser.id + '/pwd_change/', this.currentUser)
        .then(() => {
          this.loading = false;
          this.dialogChangePassword = false
        })
        .catch((err) => {
          this.render_form_errors(err)
          this.alert = true
        })
    },
    clear: function() {
      this.message = '';
      this.alert = false;
      this.$refs.changePasswordForm.resetValidation()
      this.currentUser.password = ''
      this.currentUser.password1 = ''
      this.currentUser.password2 = ''
    },
    close: function() {
      this.$refs.changePasswordForm.reset()
      this.message = '';
      this.alert = false;
      this.dialogChangePassword = false
    },    
  }
}
</script>
